import "./Resume.css";

export default function Resume() {
  const handleDownloadResume = () => {
    // Create a link element and trigger download
    const link = document.createElement("a");
    link.href = "/resume.pdf"; // Path to your PDF file in public folder
    link.download = "Tiffany_Ni_Resume.pdf"; // Name for the downloaded file
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="resumeContainer">
      <div className="resume-download-section">
        <div className="resume-header">
          <h1>Tiffany's Resume</h1>
          <p className="resume-subtitle">
            Attached is the latest version of my resume:
          </p>
        </div>

        <div className="download-card" onClick={handleDownloadResume}>
          <div className="download-icon">📄</div>
          <div className="download-content">
            <div className="download-button">
              <span>Download PDF</span>
            </div>
          </div>
        </div>

        <div className="resume-info">
          <p>
            <strong>File Format:</strong> PDF
          </p>
          <p>
            <strong>Last Updated:</strong> July 2025
          </p>
        </div>

        <div className="contact-preview">
          <h3>Quick Contact</h3>
          <p>📧 ni.tiffany130@gmail.com</p>
          <div className="social-links">
            <a
              href="http://github.com/tiffanyni"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              <img
                src="/github-mark.png"
                alt="GitHub"
                className="social-logo"
              />
            </a>
            <a
              href="https://www.linkedin.com/in/tiffany-ni-889b27299/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link"
            >
              <img
                src="https://cdn-icons-png.flaticon.com/512/174/174857.png"
                alt="LinkedIn"
                className="social-logo"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
